// What an AI dialog says while Gemini works ("Need ideas", "Get the data"). One is picked per request, so a repeat
// tap reads a little differently rather than the same sentence every time.
export const COOKING_LINES = [
  "Cooking something up…",
  "Generating content…",
  "This part always takes so long…",
  "Waiting for the other guys…",
  "Trying to go 12 parsecs…",
  "Finding some ideas…",
  "Looking for Kamino…",
  "Thinking about second breakfast…",
  "Talking to the Ents (this may take a while)…",
  "Checking our sources…",
  "Working on it…",
  "Building the Ark…",
  "Thinking about it…",
  "Just a sec…",
];

/** A random line, never the one passed in (so a rotation always visibly changes). */
export const pickCookingLine = (not?: string): string => {
  const pool = COOKING_LINES.filter((l) => l !== not);
  return pool[Math.floor(Math.random() * pool.length)]!;
};
